// utils/queryClient.js
import { QueryClient } from '@tanstack/react-query';

const queryConfig = {
    queries: {
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false
    }
};

export const queryClient = new QueryClient({
    defaultOptions: queryConfig
});
